import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { ACCESS_TOKEN, ADMIN_TOKEN } from "../../config/Config";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const NavLinks = () => {
  const navigate = useNavigate();
  const [showTNPSCDropdown, setShowTNPSCDropdown] = useState(false);
  const [showTNUSRBDropdown, setShowTNUSRBDropdown] = useState(false);
  const [showTrainingDropdown, setShowTrainingDropdown] = useState(false);
  const [showEfillingDropdown, setShowEfillingDropdown] = useState(false);

  const handleTNPSCDropdownToggle = () => {
    setShowTNPSCDropdown(!showTNPSCDropdown);
    setShowTNUSRBDropdown(false); // Close TNUSRB dropdown if open
    setShowTrainingDropdown(false); // Close training drop
  };

  const handleTNUSRBDropdownToggle = () => {
    setShowTNUSRBDropdown(!showTrainingDropdown);
    setShowTNPSCDropdown(false); // Close TNPSC dropdown if open
    setShowTrainingDropdown(false); // Close TNPSC dropdown if open
  };
  const handleTrainingDropdownToggle = () => {
    setShowTrainingDropdown(!showTrainingDropdown);
    setShowTNPSCDropdown(false); // Close TNPSC dropdown if open
    setShowTNUSRBDropdown(false); // Close TNUSRB dropdown if open
  };

  const handleEfillingDropdownToggle = () => {
    setShowEfillingDropdown(!showEfillingDropdown);
    setShowTNPSCDropdown(false);
    setShowTNUSRBDropdown(false);
  };
  const logout = () => {
    localStorage.clear();
    localStorage.removeItem(ACCESS_TOKEN);
    toast.success("Logout successfully");
    navigate("/");
  };

  return (
    <>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900"
        smooth
        to="/"
      >
        Home
      </HashLink>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900"
        smooth
        to="/about"
      >
        About
      </HashLink>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900"
        smooth
        to="/services"
      >
        Service
      </HashLink>
      <div className="relative inline-block">
        <button
          className="px-4 font-extrabold text-gray-500 hover:text-blue-900 focus:outline-none"
          onClick={handleTrainingDropdownToggle}
        >
          Loan
        </button>
        {showTrainingDropdown && (
          <div className="absolute z-10 bg-white shadow-md rounded-md mt-1">
            <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/personalLoan"
              onClick={() => setShowTrainingDropdown(false)}
            >
              Personal Loan
            </HashLink>
            <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/mortageLoan"
              onClick={() => setShowTrainingDropdown(false)}
            >
              Mortage Loan
            </HashLink>
            {/* <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/counselling"
              onClick={() => setShowTrainingDropdown(false)}
            >
              Engineering counselling
            </HashLink>
            <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/placement"
              onClick={() => setShowTrainingDropdown(false)}
            >
              Placement training
            </HashLink>
            <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/project"
              onClick={() => setShowTrainingDropdown(false)}
            >
              project training
            </HashLink> */}
          </div>
        )}
      </div>

      <div className="relative inline-block">
        <button
          className="px-4 font-extrabold text-gray-500 hover:text-blue-900 focus:outline-none"
          onClick={handleEfillingDropdownToggle}
        >
          Efilling
        </button>
        {showEfillingDropdown && (
          <div className="absolute z-10 bg-white shadow-md rounded-md mt-1">
            <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/tax"
              onClick={() => setShowEfillingDropdown(false)}
            >
              Tax
            </HashLink>
            <HashLink
              className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
              smooth
              to="/gst"
              onClick={() => setShowEfillingDropdown(false)}
            >
              GST
            </HashLink>

          </div>
        )}
      </div>

      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900"
        to="/contact#contact"
      >
        Contact Us
      </HashLink>
      {localStorage.getItem(ADMIN_TOKEN) ? (
        <>
          <HashLink
            className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
            smooth
            to="/adminDashboard"
          >
            Dashboard
          </HashLink>
          <HashLink
            className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
            smooth
            onClick={logout}
          >
            Logout
          </HashLink>
        </>
      ) : localStorage.getItem(ACCESS_TOKEN) ? (
        <>
          <HashLink
            className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
            smooth
            onClick={logout}
          >
            Logout
          </HashLink>
        </>
      ) : (
        <>
          {/*  <HashLink
            className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
            smooth
            to="/signup"
          >
            Signup
          </HashLink>
          */}
          <HashLink
            className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
            smooth
            to="/login"
          >
            Login
          </HashLink>
        </>
      )}
      <Toaster
        position="bottom-right"
        reverseOrder={false}
        toastOptions={{
          error: {
            duration: 6000,
            style: {
              background: "#FF4136",
              color: "#fff",
            },
          },

          success: {
            duration: 6000,
            style: {
              background: "#008000",
              color: "#fff",
            },
          },
        }}
      />
    </>
  );
};

export default NavLinks;
